<template>
  <div class="flex flex-col w-full justify-center">
    <dev-environment-color />
    <transition name="fade-in" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import tenant from '@/mixins/tenant.js'
import token from '@/mixins/token'

export default {
  mixins: [tenant, token],
  name: 'app',
  data () {
    return {}
  },
  components: {
    DevEnvironmentColor: () =>
      import('@/components/base/DevEnvironmentColor.vue'),
    Transition: () =>
      import('@/components/v2/animation/transition/Transition.vue')
  },
  computed: {
    userTheme () {
      return this.$store.state.common.userTheme
    },
    gradientPrimaryColor () {
      return process.env.VUE_APP_TENANT_NAME === 'torus' ? '#D0E3FC' : '#f4a177'
    }
  },
  watch: {
    '$store.state.common.userTheme': function () {
      this.setTheme(this.$store.state.common.userTheme)
    }
  },
  methods: {
    setTheme (theme) {
      document.documentElement.className = `${theme} ${this.tenantName} ${this.tenantVersion}`
    }
  },
  beforeCreate () {
    this.getToken()
  },
  mounted () {
    this.setTheme(this.userTheme)
    const tenantStyles = document.body.style
    tenantStyles.setProperty('--color-primary', this.tenantPrimaryColor)
    tenantStyles.setProperty('--color-secondary', this.tenantSecondaryColor)
    tenantStyles.setProperty('--primary-gradient', this.gradientPrimaryColor)
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/_variables.scss';
.el-dialog__headerbtn .el-dialog__close {
  margin-right: 12px;
  margin-top: 10px;
}
.el-dialog {
  border-radius: 30px;
  padding: 5px;
  background-color: var(--background);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
